/* eslint-disable object-property-newline */
export const YESNO = [
  {
    label: "YES",
    value: "yes" 
  },
  {
    label: "NO",
    value: "no" 
  },
];

export const TITLES = ["Mr", "Mrs", "Miss", "Ms", "Dr"];
export const EMAIL_FIELDS = [
  { label: "CP Url", value: "cpUrl", },
  { label: "CRM Url", value: "crmUrl", },
  { label: "Customer Support Name", value: "customerSupportName", },
  { label: "First Name", value: "firstName", },
  { label: "Last Name", value: "lastName", },
  { label: "Email", value: "email" },
  { label: "Amount", value: "amount" },
  { label: "Currency", value: "currency" },
  { label: "Reset Link", value: "resetLink" },
  { label: "Account Login", value: "login" },
  { label: "Account Login To", value: "loginTo" },
  { label: "Platform", value: "platform" },
  { label: "Password", value: "password" },
  { label: "Investor Password", value: "investorPassword" },
  { label: "Password Type", value: "type" },
  { label: "Gateway", value: "gateway" },
  { label: "Amount", value: "amount" },
  { label: "Investor Password", value: "investorPassword" },
  { label: "Rejection Reason", value: "rejectionReason" },
  { label: "PIN", value: "pin" },
];
